import axios from "axios";
import authHeader from "./auth-header";
const API_URL = process.env.VUE_APP_API_BASE_URL + '/';

export default {
  async login(user) {
    const response = await axios.post(API_URL + "login", user);
    if (response.data.access_token) {
        localStorage.setItem("token", JSON.stringify(response.data.access_token));
    }
  },

  async logout() {
    try {
      try{
        await axios.post(API_URL + "logout", null, { headers: authHeader() });
      } catch{
      }
    } finally {
      try{
        localStorage.removeItem("token");
      } catch{ 
      } 
    }
  },

  async register(user) {
    try {
      const response = await axios.post(API_URL + "register", user);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },

  async acessoAntecipado(user) {
    try {
      const response = await axios.post(API_URL + "acesso-antecipado", user);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  }
};
